import _ from 'lodash';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import { canUseMemo, getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { PriorityPicker } from '@/workbook/PriorityPicker.molecule';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { CustomPriority } from '@/tools/thresholdMetric/metric.types';
import type { TooltipPosition } from '@seeqdev/qomponents';

export interface PriorityPickerIF extends Omit<
  ValidatingFormComponent<number | CustomPriority[] | undefined>,
  'onChange'
> {
  component: 'PriorityPickerFormComponent';
  placement: TooltipPosition;
  buttonTooltip?: string;
  buttonTooltipPlacement?: TooltipPosition;
  buttonTestId: string;
  buttonClasses: string;
  onChange?: (value: number) => void;
}

const PriorityPickerFormComponentUnwrapped = (props: PriorityPickerIF) => {
  const { name, validation, extendValidation, extraClassNames } = props;

  const defaultValidation = (value: number | CustomPriority[] | undefined) => _.isEmpty(value);
  const formState = useForm().getState();

  return (
    <Field<CustomPriority[] | number | undefined>
      name={name}
      validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
      {({ input, meta }) => (
        <div className={extraClassNames}>
          <PriorityPicker {...getFormFieldProps(formState, input, meta, props)} />
        </div>
      )}
    </Field>
  );
};

export const PriorityPickerFormComponent = React.memo(PriorityPickerFormComponentUnwrapped, canUseMemo);
